// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zqiijdpajcgvehheqihi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpxaWlqZHBhamNndmVoaGVxaWhpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc4MzA2MTcsImV4cCI6MjA1MzQwNjYxN30.vU784K8zren8_AmasT6btj2oppygY2n_ZwxHhJHZS3I";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY, 
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storageKey: 'hackscore-auth',
      detectSessionInUrl: false
    }
  }
);
